import L, {
  LeafletMouseEvent,
  LatLngExpression,
  Map,
  LeafletEvent,
} from 'leaflet';
import { initialCenterWCC } from './constants';
import { shimmer } from '../mapUtils';

export const loadingPopup = (event: LeafletMouseEvent, map: Map) => {
  L.popup({ closeOnClick: true })
    .setLatLng(event.latlng)
    .setContent(shimmer())
    .openOn(map);
};

export const outsideBoroughPopup = (event: LeafletMouseEvent, map: Map) => {
  L.popup({ closeOnClick: true })
    .setLatLng(event.latlng)
    .setContent(
      `<div style="background-color: #FFCCCC; padding: 10px; border-radius: 5px;">
              <span>You selected a location outside the borough, try again</span></div>`,
    )
    .openOn(map);
};

export const errorZoomInPopup = (event: LeafletMouseEvent, map: Map) => {
  L.popup({ closeOnClick: true })
    .setLatLng(event.latlng)
    .setContent(
      `<div style="background-color: #FFCCCC; padding: 10px; border-radius: 5px;">
              <span>Zoom in closer to select a accurate location</span></div>`,
    )
    .openOn(map);
};

export const geolocationOutOfBoroughPopup = (map: Map) => {
  map.flyTo(initialCenterWCC, 13);
  L.popup({ closeOnClick: true })
    .setLatLng(initialCenterWCC)
    .setContent(
      `<div style="background-color: #FFCCCC; padding: 10px; border-radius: 5px;">
              <span>Your location needs to be inside the borough.</span></div>`,
    )
    .openOn(map);
};

export const tflBoundaryPopup = (event: LeafletMouseEvent, map: Map) => {
  L.popup({ closeOnClick: true })
    .setLatLng(event.latlng)
    .setContent(
      `<div style="background-color: #FFD420; padding: 10px; border-radius: 5px;">
              <span>Westminster City Council does not maintain this road. It is managed by Transport for London (TfL)</span></div>`,
    )
    .openOn(map);
};

/**
 * The error message is specified in the story, refer to here: {@link https://westminstergov.atlassian.net/browse/RITE-1248}
 */
export const wasteAddressErrorPopup = (event: LeafletMouseEvent, map: Map) => {
  L.popup({ closeOnClick: true })
    .setLatLng(event.latlng)
    .setContent(
      `<div style="background-color: #FFCCCC; padding: 10px; border-radius: 5px;">
              <span>We cannot retrieve an address and may not provide waste related services for this location. If you want to try again, please select a different location.</span></div>`,
    )
    .openOn(map);
};

export const addressErrorPopup = (map: Map, event?: LeafletMouseEvent) => {
  const popupLocation: LatLngExpression = event?.latlng || initialCenterWCC;
  const popupContent = `<div style="background-color: #FFCCCC; padding: 10px; border-radius: 5px;">
              <span>We cannot retrieve an address for this location. If you want to try again, please select a different location.</span></div>`;

  L.popup({ closeOnClick: true })
    .setLatLng(popupLocation)
    .setContent(popupContent)
    .openOn(map);
};
